import React from 'react';
export class CnListProItemAvatar extends React.Component {
    render() {
        return <>{this.props.children}</>;
    }
}
CnListProItemAvatar.displayName = 'CnListProItemAvatar';
